import { createAuthClient } from 'better-auth/client'
import { adminClient, organizationClient } from 'better-auth/client/plugins'

/** Better Auth's routes on the admin API (`AUTH_BASE_PATH` in the backend). */
const AUTH_BASE_PATH = '/api/auth'

/**
 * Better Auth client for the admin API. Plugins mirror the server's (`admin`
 * for platform staff, `organization` for tenants) so their endpoints and the
 * `role` field are typed. The session is an HttpOnly cookie on the API's
 * origin, so every request sends credentials.
 */
export function createAdminAuthClient(apiUrl: string) {
  return createAuthClient({
    baseURL: apiUrl,
    basePath: AUTH_BASE_PATH,
    fetchOptions: { credentials: 'include' },
    plugins: [adminClient(), organizationClient()],
  })
}

export type AdminAuthClient = ReturnType<typeof createAdminAuthClient>
